export const buildingInclude =
	'clients:withoutBanned(true),buildingProductStates.product,allBuildingProductStates.product,allEncounters';

export const encountersInclude = 'source.user';

export const encounterInclude =
	'building,source.formFill.formAttributes,source.calendarResource.client,source.calendarResource.salesmanVisit,source.calendarResource.salesman,source.calendarResource.team,source.user,reasonMapping';

export const freeCalendarResourceInclude = 'organization,salesman,team';

export const visitFormBase = {
	// meta
	state: 'contacted', // visit,contacted
	dateCreatorOpen: false,
	isBonus: false,
	// values
	calendarResourceId: null,
	calendarResource: {
		dateFrom: null,
		teamId: null,
		ihSource: null,
	},
	bonusCalendarResource: {
		dateFrom: null,
		teamId: null,
		salesmanId: null,
	},
	contactClientId: null,
	reason: null,
	reasonMappingId: null,
	reached: true,
	description: '',
	formFill: {
		description: '',
	},
};

export const createEmptyClient = () => ({
	firstName: '',
	lastName: '',
	email: '',
	password: '',
	swedish: false,
	comments: '',
	title: '',
	address: '',
	zip: '',
	city: '',
});

export const forwardingReferrers = ['listview', 'freeride', 'salesman-app-contacts'];

export const notHomeBase = {
	appointment: false,
	reached: false,
	preferredEncounterState: 'notHome',
};
